var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-card"},[_c('img',{attrs:{"src":require(`@components/assets/Configurations/${_vm.icon}`),"alt":""}}),_c('div',{staticClass:"panel-text-class"},[_c('span',{staticClass:"panel-title-class"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"panel-subtext-class"},[_vm._v(" "+_vm._s(_vm.truncatedSubtext)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }